/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandBook } from '../models/BrandBook';
import type { BrandBookRead } from '../models/BrandBookRead';
import type { BrandCreate } from '../models/BrandCreate';
import type { BrandListItem } from '../models/BrandListItem';
import type { BrandRead } from '../models/BrandRead';
import type { BrandUpdate } from '../models/BrandUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandService {
    /**
     * List Brands
     * Every active brand the account belongs to, oldest first, with its lock state.
     * @returns BrandListItem Successful Response
     * @throws ApiError
     */
    public static listBrands(): CancelablePromise<Array<BrandListItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brands',
        });
    }
    /**
     * Create Brand
     * Add a brand to the account, up to what its plan allows.
     * @param requestBody
     * @returns BrandRead Successful Response
     * @throws ApiError
     */
    public static createBrand(
        requestBody: BrandCreate,
    ): CancelablePromise<BrandRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/brands',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Archive Brand
     * Delete a brand: it is archived, hidden and no longer counted against the plan.
     * @param brandId
     * @returns void
     * @throws ApiError
     */
    public static archiveBrand(
        brandId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/brands/{brand_id}',
            path: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Brand
     * One brand by id. The caller must be a contact on it.
     * @param brandId
     * @returns BrandRead Successful Response
     * @throws ApiError
     */
    public static getBrand(
        brandId: number,
    ): CancelablePromise<BrandRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brands/{brand_id}',
            path: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Brand
     * Edit brand details. Changing the website is what a re-scrape reads from.
     * @param brandId
     * @param requestBody
     * @returns BrandRead Successful Response
     * @throws ApiError
     */
    public static updateBrand(
        brandId: number,
        requestBody: BrandUpdate,
    ): CancelablePromise<BrandRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/brands/{brand_id}',
            path: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * My Brand
     * The signed-in account's oldest active brand.
     * @returns BrandRead Successful Response
     * @throws ApiError
     */
    public static myBrand(): CancelablePromise<BrandRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brands/me',
        });
    }
    /**
     * Get Brand Book
     * What the chat agent reads about the brand before it writes.
     * @param brandId
     * @returns BrandBookRead Successful Response
     * @throws ApiError
     */
    public static getBrandBook(
        brandId: number,
    ): CancelablePromise<BrandBookRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/brands/{brand_id}/book',
            path: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Brand Book
     * Edit the brand book. Only the fields sent change.
     * @param brandId
     * @param requestBody
     * @returns BrandBookRead Successful Response
     * @throws ApiError
     */
    public static updateBrandBook(
        brandId: number,
        requestBody: BrandBook,
    ): CancelablePromise<BrandBookRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/brands/{brand_id}/book',
            path: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Brand Book
     * Draft the brand book from the brand's website, in the background.
     * @param brandId
     * @returns BrandBookRead Successful Response
     * @throws ApiError
     */
    public static generateBrandBook(
        brandId: number,
    ): CancelablePromise<BrandBookRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/brands/{brand_id}/book/generate',
            path: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
